// Mutuantes vinculados — lenders Finzo holds a binding contract with.
//
// This list is a legal disclosure under Decreto-Lei n.º 81-C/2017 art. 6º
// and MUST mirror, verbatim and in the same order, the "Identificação dos
// mutuantes ou grupos com quem mantém contrato de vinculação" block on
// https://www.bportugal.pt/intermediariocreditofar/finzo-lda
//
// `legalName` is the BdP registry string and is deliberately NOT translated.
// `displayName` is the commercial name used in marketing surfaces.
//
// Do not confuse this with `features/pro/clients/adapters/partnerConfig.ts`,
// which tracks which partners have a live submission integration in the Pro
// area — a different question with a different answer.

export interface BoundLender {
  id: string;
  /** Verbatim name as published on the BdP registry. */
  legalName: string;
  /** Commercial name for marketing surfaces. */
  displayName: string;
  logoSrc: string;
  logoWidth: number;
  logoHeight: number;
}

export const BOUND_LENDERS: readonly BoundLender[] = [
  {
    id: "cgd",
    legalName: "CAIXA GERAL DE DEPÓSITOS, S.A.",
    displayName: "Caixa Geral de Depósitos",
    logoSrc: "/images/partners/cgd.webp",
    logoWidth: 350,
    logoHeight: 350,
  },
  {
    id: "uci",
    legalName:
      "UNION DE CRÉDITOS INMOBILIÁRIOS, S.A., ESTABLECIMIENTO FINANCIERO DE CRÉDITO (SOCIEDAD UNIPERSONAL) - SUCURSAL EM PORTUGAL",
    displayName: "UCI",
    logoSrc: "/images/partners/uci.webp",
    logoWidth: 442,
    logoHeight: 196,
  },
  {
    id: "bankinter",
    legalName: "BANKINTER, S.A. - SUCURSAL EM PORTUGAL",
    displayName: "Bankinter",
    logoSrc: "/images/partners/bankinter.webp",
    logoWidth: 128,
    logoHeight: 128,
  },
  {
    id: "credito_agricola",
    legalName: "SICAM - CAIXA CENTRAL E CAIXAS DE CRÉDITO AGRÍCOLA MÚTUO",
    displayName: "Crédito Agrícola",
    logoSrc: "/images/partners/credito_agricola.webp",
    logoWidth: 500,
    logoHeight: 263,
  },
  {
    id: "banco_ctt",
    legalName: "BANCO CTT, S.A.",
    displayName: "Banco CTT",
    logoSrc: "/images/partners/banco_ctt.webp",
    logoWidth: 372,
    logoHeight: 186,
  },
  {
    id: "bpi",
    legalName: "BANCO BPI S.A.",
    displayName: "Banco BPI",
    logoSrc: "/images/partners/bpi.webp",
    logoWidth: 128,
    logoHeight: 128,
  },
] as const;
